// The Congregation: a persistent tally of every cult leader ever delivered
// to the sacred stone, across all runs. Pure lore metagame — collect all 31.

import { ROSTER, type CultMember } from './roster';

const KEY = 'takemetoyourledger:souls:v1';

type SoulStore = Record<string, number>;

function load(): SoulStore {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw) as SoulStore;
  } catch { /* ignore */ }
  return {};
}

function save(store: SoulStore): void {
  try { localStorage.setItem(KEY, JSON.stringify(store)); } catch { /* ignore */ }
}

export interface SoulRecord {
  first: boolean;      // first time this member was ever delivered
  gathered: number;    // distinct members delivered so far
  total: number;       // roster size
}

/** Record a delivery. Returns whether it was a new soul and the tally. */
export function recordSoul(memberId: string): SoulRecord {
  const store = load();
  const first = store[memberId] === undefined;
  store[memberId] = (store[memberId] ?? 0) + 1;
  save(store);
  return { first, gathered: Object.keys(store).length, total: ROSTER.length };
}

export function gatheredCount(): number {
  return Object.keys(load()).length;
}

export function congregationState(): { member: CultMember; count: number }[] {
  const store = load();
  return ROSTER.map((member) => ({ member, count: store[member.id] ?? 0 }));
}
